import { render, staticRenderFns } from "./TermOfUseWindenergie.vue?vue&type=template&id=576090d6&"
import script from "./TermOfUseWindenergie.vue?vue&type=script&lang=js&"
export * from "./TermOfUseWindenergie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports